import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaPlanAnualCultura from './TablaPlanAnualCultura';

const PlaneacionCultural: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaPlanAnualCultura />
    </Box>
  );
};

export default PlaneacionCultural;
